import axiosClient from "./axiosClient";

const shopeApi = {
    getProductInfo: (link) => {
        const baseURL = "shopee/product-commission";
        return axiosClient.post(baseURL, {
            link,
        });
    },
    getProductByKeyword: (keyword, sortType) => {
        const baseURL = "shopee/get-product-by-keyword";
        return axiosClient.post(baseURL, {
            keyword,
            sortType,
        });
    },
    getRecommendProductList: () => {
        const baseURL = "shopee/recommend-product-list";
        return axiosClient.get(baseURL);
    },
    getRecommendShopList: (size) => {
        const baseURL = `shopee/recommend-shop-list?size=${size || ""}`;
        return axiosClient.get(baseURL);
    },
    getLinkAff: (link, source) => {
        return axiosClient.post('shopee/get-link', { link, ...(source && { source }) });
    },
    convertLink: (link, source) => {
        return axiosClient.post('shopee/convert-link', { link, ...(source && { source }) });
    },
    findOrder: (orderId) => {
        const baseURL = "shopee/find_order";
        return axiosClient.post(baseURL, {
            orderId,
        });
    },
    getGhostLinkAff(link, source) {
        return axiosClient.post('ghostshopee/get_link', { link, ...(source && { source }) });
    },
    getLinkAffVideo: (link, source) => {
        return axiosClient.post('shopee/get-link-shopeevideo', { link, isShopeeXu: true, ...(source && { source }) });
    },
    getAffLinkExtension(link, source) {
        return axiosClient.post('extension/get_link_aff', { link, ...(source && { source }) });
    },
};

export default shopeApi;
